import React from "react";
import CreateList from "./CreateList";
import { ListContextProvider } from "contextAPI/ListsContext";

function CreateListIndex() {
  return (
    <ListContextProvider>
      <CreateList />
    </ListContextProvider>
  );
}

export default CreateListIndex;
